if (!customElements.get('page-accordion')) {
  class PageAccordion extends HTMLElement {
    constructor () {
      super()

      this.itemEls = this.querySelectorAll('[data-el="page-accordions.item"]')

      this.initialiseAccordions()
    }

    initialiseAccordions () {
      this.itemEls.forEach(itemEl => {
        const triggerEl = itemEl.querySelector(
          '[data-el="page-accordions.trigger"]'
        )

        this.handleClick = this.handleClick.bind(this)

        triggerEl.addEventListener('click', this.handleClick)
      })
    }

    handleClick (event) {
      const currentState =
        event.target
          .closest('[data-el="page-accordions.item"]')
          .getAttribute('aria-expanded') === 'true'

      event.target
        .closest('[data-el="page-accordions.item"]')
        .setAttribute('aria-expanded', !currentState)
    }
  }

  customElements.define('page-accordions', PageAccordion)
}
